<template>
  <div>
    <common-dialog ref="dialog" width="500px" line-form show-save-button unit="部门" edit-title id-key="DpId" :data="data"
      @create-opened="onCreateOpened" @edit-opened="onEditOpened" @opened="onOpened" :form-rules="rules"
     :save-func="api.save"  @close-saved="$emit('close-saved')" @closed="onClosed">
      <template slot="form">

        <el-form-item label="部门编码" prop="DpNo">
          <span v-if="Mode==0" class="detail-span">{{data.DpNo}}</span>
              <el-input v-else v-model="data.DpNo" placeholder="请输入部门编码"></el-input>

         
        </el-form-item>
        <el-form-item label="部门名称" prop="DpName">
          <el-input v-model="data.DpName" placeholder="请输入部门名称" />
        </el-form-item>
        <template v-if="iShow('Pid')">
          <el-form-item label="上级部门">
            <tree-select ref="treeSelect" :props="props" :options="TreeData" :value="data.Pid" :clearable="false"
              :accordion="true" :parentSelect="true" placeholder="请选择" @node-select="onTreeSelect($event)" />
            <!-- <el-select v-model="data.Pid" clearable>
              <el-option v-for="item in DpList" :key="item.DpId" :value="item.DpId" :label="item.DpName"
                @click.native="toggleDP(item)"></el-option>
            </el-select> -->
          </el-form-item>
        </template>
        <template v-if="iShow('EmpName')">
          <el-form-item label="负责人">
            <select-input placeholder="请选择负责人" :label="data.EmpName" v-model="data.EmpId" @click="openEmp" />
          </el-form-item>
        </template>
        <el-form-item label="序号" prop="SerialNumber">
          <el-input type="number" v-int v-model="data.Sn" style="width: 100px"></el-input>
          <!-- <el-input-number v-model.number="data.Sn" :min="0" step-strictly style="width: 100px" ></el-input-number> -->
          <span class="t-tips">*值越小排得越前</span>
        </el-form-item>
        <el-form-item prop="Status" class="notBottom">
          <el-checkbox v-model="data.Status" :true-label="0" :false-label="1">停用</el-checkbox>
        </el-form-item>



      </template>
    </common-dialog>
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import empDialog from "@/components/personnel/result/record/listDialog";
import treeSelect from "@/components/common/treeSelect";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    empDialog,
    treeSelect
  },
  data() {
    return {
      data: {
        DpId: 0,
        DpNo: "",
        DpName: "",
        EmpId: null,
        EmpName: "",
        Pid: null,
        Pname: "",
        Status: 1,
        Sn: null,
      },
      Mode:1,
      code_api: require("@/api/sy/serialCode").default,
      formApi: require("@/api/sy/formSetting").default,
      api: require("@/api/ent/dp").default,
      DpList: [],
      showList: [],
      TreeData: [],
      props: {
        value: "DpId",
        label: "DpName",
        children: "children",
      },
      rules: {
        Sn: [{ required: true, message: "序号不能为空" }],
        DpNo: [{ required: true, message: "部门编码不能为空" }],
        DpName: [{ required: true, message: "部门名称不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    onClosed(){
      this.api.list({Status: 1}).then((res) => {
        var dpList = this.$commonJs.toTreeData(res.Data, "DpId");
        localStorage.setItem('dpList',JSON.stringify(dpList))
      });
    },
    serialCode(){
      this.code_api.previewNo("部门").then((res) => {
        console.log("serialType", res);
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.DpNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取部门编号失败");
        }
      });
    },
    onCreateOpened(data) {

      this.serialCode();
      this.api.getMaxSn().then((res) => {
        this.data.Sn = res;
      });
      this.data.DpId = 0;
      this.data.Pid = null;
      this.data.DpName = "";
      console.log(data,"data")
      this.$refs.treeSelect.valueTitle=""
      this.api.list({}).then((res) => {
        this.TreeData = this.arrayToTree(res.Data.filter(item=>item.DpId != this.data.DpId))
      });
    },
    onEditOpened(data) {
      this.api.list({}).then((res) => {
        this.TreeData = this.arrayToTree(res.Data.filter(item=>item.DpId != this.data.DpId))
        this.$refs.treeSelect.setData(this.data.DpId);
      });
    },
    onOpened() {
      console.log(this.data,'修改前结果')
      let modeName = this.urlHash ? this.urlHash.split("/").join("") : location.hash.split("/").slice(1).join("");
      this.formApi.list({ type: modeName }).then((res) => {
        this.showList = res.Data?.map((x) => x.ShowField);
      });
    },
    // onOpened() {
    //   // this.$refs.typeSelect.init();
    // },
    //判断显示
    iShow(data) {
      if (this.showList == null || this.showList.length === 0) return true;
      return this.showList.indexOf(data) !== -1 ? true : false;
    },
    openEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData();
      });
    },
    setEmp(data) {
      this.data.EmpId = data.EmpId;
      this.data.EmpName = data.EmpName;
    },
    toggleDP(data) {
      this.Pname = data.Pname
    },
    onTreeSelect(t) {
      if (!t) {
        this.data.Pname = "";
        this.data.Pid = null;
        // this.data.CarId = null;
        // this.data.CarNo = null;
      } else {
        this.data.Pname = t.DpName;
        this.data.Pid = t.DpId;
        this.data.IdChain = t.IdChain;
      }
    },
    arrayToTree(items) {
      console.log("保存成功")
      const result = [];   // 存放结果集
      const itemMap = {};  // 
      for (const item of items) {
        const id = item.DpId;
        const pid = item.Pid;

        if (!itemMap[id]) {
          itemMap[id] = {
            children: [],
          }
        }

        itemMap[id] = {
          ...item,
          children: itemMap[id]['children']
        }

        const treeItem = itemMap[id];

        if (pid === 0) {
          result.push(treeItem);
        } else {
          if (!itemMap[pid]) {
            itemMap[pid] = {
              children: [],
            }
          }
          itemMap[pid].children.push(treeItem)
        }

      }
      return result;
    }


  },
};
</script>

<style lang="scss" scoped>
/deep/ .notBottom .el-form-item__content {
  border-bottom: none;
}
</style>